import { lazy, useMemo } from "react";
import { type RouteObject } from "react-router";
import { useBerechtigt } from "../../components/Guard";

const KundenListe = lazy(() => import("./KundenListe"));
const KundenDialog = lazy(() => import("./KundenDialog"));

export function useKundenRoutes(): Array<RouteObject> {
  const enabled = useBerechtigt({ berechtigung: "test-station:liste" });

  return useMemo(
      () =>
          enabled
              ? [
                {
                  path: "kunden",
                  element: <KundenListe />,
                  children: [
                    { path: "neu", element: <KundenDialog /> },
                    { path: ":kundenId", element: <KundenDialog /> },
                  ],
                },
              ]
              : [],
      [enabled]
  );
}
